import { composeClassNames } from "@faedev/editor-utils";
import { Col, Row } from "react-bootstrap";
import Heading from "src/components/Heading";
import gutter from "src/functions/gutter";
import { sAlign } from "src/styles/sAlign.module.scss";
import { sList } from "src/styles/sList.module.scss";

function UserTermsPrivacyEn9() {
  return (
    <div>
      <Heading
        type={`h3`}
        title={
          <>
            {`IX.`}
            <br />
            {`Sending business messages and storing cookies`}
          </>
        }
        className={composeClassNames([sAlign, "center"])}
        style={gutter(`margin`, `top`, `md`)}
      />
      <Row>
        <Col sm={6} xs={12}>
          <ol className={sList}>
            <li>{`The User agrees to the sending of information related to the Provider's services to the User's electronic address and further agrees to the sending of the Provider's business messages to the User's electronic address.`}</li>
          </ol>
        </Col>
        <Col sm={6} xs={12}>
          <ol start={2} className={sList}>
            <li>{`The User agrees to the storage of so-called cookies on their computer, where the individual conditions are agreed by the User within the access to the Provider's website.`}</li>
          </ol>
        </Col>
      </Row>
    </div>
  );
}

export default UserTermsPrivacyEn9;
